module.exports = __webpack_public_path__ + "img/I_talk.05a6a94c.gif";